<div class="locking-wrap">
  <div class="locking-header">
    <h3>Business Lock</h3>
    <input
      type="text"
      placeholder="Search Business..."
      [(ngModel)]="searchText"
    />
  </div>

  @if (loading) {
<div class="loading">
    <i class="fa fa-spinner fa-spin"></i>
  </div>
}

  @if (!loading) {
<div class="tree">
    <ng-container *ngTemplateOutlet="nodeList; context: { $implicit: nodes, level: 0 }"></ng-container>
  </div>
}

  <div class="actions">
    <button type="button" class="save-btn" [disabled]="saving" (click)="save()">
      @if (saving) {
<span><i class="fa fa-spinner fa-spin"></i></span>
}
      Save
    </button>
  </div>
</div>

<ng-template #nodeList let-list let-level="level">
  @for (node of list; track trackByNode($index, node)) {
<div class="node-row" [style.paddingLeft.px]="12 + level * 18" [hidden]="!canShowNode(node)">
    @if (node.children?.length) {
<button
     
      class="expander"
      type="button"
      (click)="toggleExpand(node)">
      <i class="fa" [ngClass]="node.collapsed ? 'fa-caret-right' : 'fa-caret-down'"></i>
    </button>
}
    @if (!(node.children?.length)) {
<span class="expander-placeholder"></span>
}

    <i class="fa folder" [ngClass]="node.collapsed ? 'fa-folder' : 'fa-folder-open'"></i>
    <span class="name">{{ node.name }} ({{ node.mekey }})</span>
    <i class="fa lock" [ngClass]="node.selected ? 'fa-lock' : 'fa-unlock'"></i>
    <input
      type="checkbox"
      [checked]="!!node.selected"
      (change)="onToggleNode(node, $any($event.target).checked)"
    />
  </div>
}

  @for (node of list; track trackByNode($index, node)) {

    @if (node.children?.length && !node.collapsed) {

      <ng-container *ngTemplateOutlet="nodeList; context: { $implicit: node.children, level: level + 1 }"></ng-container>
    
}
  
}
</ng-template>
